<template>  
  <v-container grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <v-flex xs12 md4>
        <form @submit.prevent="onsubmit">
        <v-card>                    
          <v-card-text>      
            <v-text-field
              label="ID"
              v-model="fm.id"
              type="text"
              :error="!!error.id.length"
              :error-messages="error.id"
            ></v-text-field>            

            <v-select
              v-model="fm.level"
              :items="levels"
              label="Level"
              item-text="name"
              item-value="id"
            ></v-select>

            <v-text-field
              label="Name"
              v-model="fm.name"
              append-icon="room"
              type="text"
              :error="!!error.name.length"
              :error-messages="error.name"
            ></v-text-field>            

            <v-autocomplete
              v-model="fm.parent_id"
              label="Parent"
              :items="parents"
              item-text="name"
              item-value="id"
              @keyup="search"
            >
              <template v-slot:item="data">
                <template v-if="typeof data.item !== 'object'">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    <v-list-item-subtitle>level : {{ 
                      levels.find(x=>x.id===data.item.level)? 
                        levels.find(x=>x.id===data.item.level).name:
                        data.item.level
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>
            </v-autocomplete>

            <v-text-field
              label="Kode Pos"
              v-model="fm.kodepos"
              append-icon="contact_mail"
              type="text"
              :error="!!error.kodepos.length"
              :error-messages="error.kodepos"
            ></v-text-field>                       

            <v-text-field
              label="Compare ID"
              v-model="fm.compare_id"
              append-icon="code"
              type="text"              
            ></v-text-field> 
                      
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn type="submit" :color="isUpdate?'blue':'green'" :loading="loading" dark>{{isUpdate?'update':'create'}}</v-btn>
          </v-card-actions>
        </v-card>
        </form>   
      </v-flex>            
    </v-layout>
  </v-container>    
</template>

<script>
import { debounce } from 'lodash'
import model from '@/app/models/master/Node'

export default {
  data : () => ({  
    fm:{id:null, level: null, name: null, parent_id:null, kodepos:null, compare_id:null},
    error:{id:[], level: [], name : [], parent_id : [], kodepos:[], compare_id:[]},
    loading: false,
    isUpdate: false,    
    mode: 0,        
    parents: []
  }),
  computed:{
    levels(){
      let obj = this.$store.getters.DICTIONS.RegionLevel;
      return Object.keys(obj).map(function(key) { return {id:parseInt(key), name: obj[key]}; });
    }
  },
  watch:{
    'fm.parent_id'(newId, oldId){
      if(oldId===null && newId !== null){
        model.view({id:newId}).then(data=>{
          this.parents.push(data);
        })    
      }
    }
  }, 
  mounted(){
    if(this.$route.query.id){
      this.isUpdate = true;
      model.view({id:this.$route.query.id}).then(data=>{                
        Object.assign(this.fm, data);
      })
    }
  },
  methods: {
    search: debounce(function (e) {      
      this.readParents(e.target.value)
    }, 800),

    readParents(term){
      model.index({q:term}).then(res=>{
        this.parents = res.data;
      })
    },

    onsubmit(){
      this.loading = true;  this.clearErrors();
      if(this.isUpdate){        
        model.update(this.fm, {id:this.fm.id}).then(res=>{this.responseSubmit(res)})
      } else {        
        model.create(this.fm).then(res=>{this.responseSubmit(res)})
      }
    },

    responseSubmit(res){
      this.loading = false;
      if(res.status === 200){
        window.getApp.$emit('showSnackbar', {text :'Data has been saved successfully', color: 'green', show:true});            
        this.$router.replace({name:'master/nodes'})                
      } else {
        this.validate(res.data);
      }
    },

    validate(data){      
      for(var i in data){        
        if(Array.isArray(this.error[data[i]['field']])){          
          this.error[data[i]['field']].push(data[i]['message']);
        }        
      }
    },

    clearErrors(){
      this.error.name    = [];
      this.error.type    = [];
      this.error.address = [];
      this.error.email   = [];
      this.error.node_id = [];      
    }
  },
}
</script>

<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>